// @ts-nocheck

import { sendFormData } from "@legacy/modules/form.module.ts";

const formHandlers = new WeakMap();

function initFormHandle() {
    const forms = document.querySelectorAll("[data-handle-form-submit=true]");
    for (const form of forms) {
        if (formHandlers.has(form)) continue;
        if (form instanceof HTMLFormElement) {
            form.addEventListener("submit", (e) => {
                e.preventDefault();
                formSubmitHandler(form);
            });
            formHandlers.set(form, {});
        }
    }
}

/**
 * Обработчик отправки формы
 * @param {HTMLFormElement} form
 */
function formSubmitHandler(form) {
    let formSuccessHandler;
    if (form.dataset.formSuccessHandler) {
        formSuccessHandler = window[form.dataset.formSuccessHandler];
    }
    let formErrorHandler;
    if (form.dataset.formErrorHandler) {
        formErrorHandler = window[form.dataset.formErrorHandler];
    }
    sendFormData(form, formSuccessHandler, formErrorHandler);
}

initFormHandle();

function showHidePassword(target) {
    let input = target.parentElement.getElementsByTagName("input")[0];
    if (input.getAttribute("type") === "password") {
        target.classList.add("view");
        input.setAttribute("type", "text");
    } else {
        target.classList.remove("view");
        input.setAttribute("type", "password");
    }
    return false;
}

window["showHidePassword"] = showHidePassword;
